import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { GiftModel } from '../models/gift';
import { Student } from '../models/student';
import { environment } from '../../environments/environment';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';
import { UserErrorHandlerService } from '../../app/services/user-error-handler.service';

@Injectable({ providedIn: 'root' })
@EasyDebugDecorator
export class GiftsService {
  private _gifts: Array<GiftModel> = [];
  constructor(
    private http: HttpClient,
    private userErrorHandlerService: UserErrorHandlerService
  ) {}

  fetchGiftsByUserId(accountId: string): Observable<GiftModel[]> {
    let url: string;

    if (!!accountId) {
      url = `${environment.token_auth_config.apiBase}/v${environment.apiVersion}/account/${accountId}/gifts`;

      return this.http.get(url).pipe(
        switchMap((data) => {
          this._gifts = this.buildGiftsFromRawData(data);
          return of(this._gifts);
        }),
        catchError(async (err) => {
          this.userErrorHandlerService.addError({
            criticity: 1,
            service: 'gifts',
            platform: 'both',
            data: err,
            errorCode: 'gsfgbuid',
          });
          return [];
        })
      );
    }
  }

  async loadStudentGifts(student: Student) {
    if (student.isGuest()) {
      this._gifts = [];
    } else {
      this.fetchGiftsByUserId(student.remoteId).subscribe((res) => {
        this._gifts = res;
      });
    }
  }

  ///////////////////////////////////
  /////          GETTERS       /////
  ///////////////////////////////////

  get gifts(): Array<GiftModel> {
    return this._gifts;
  }

  buildGiftFromRawData(data: any): GiftModel {
    return new GiftModel({
      id: data.id,
      type: data.type,
      credits: data.attributes.credits,
      driving_exam_credits: data.attributes.driving_exam_credits,
      code: data.attributes.code,
      description: data.attributes.description,
      created_at: data.attributes.created_at,
      updated_at: data.attributes.updated_at,
    });
  }

  buildGiftsFromRawData(data: any): Array<GiftModel> {
    const arr: Array<GiftModel> = [];
    if (!!data && !!data.data && data.data.length > 0) {
      for (const gift of data.data) {
        arr.push(this.buildGiftFromRawData(gift));
      }
    }
    return arr;
  }
}
